/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createActionsHook,
	type Action,
	type BoundActions,
	type HookActionsFunction,
	type Store,
} from '@atlassian/react-sweet-state';
import type { Props, State } from './ProductSettingsResponse.types.tsx';
import { loadProductSettings } from './loadProductSettings.tsx';
import { updateDatesInitialMonth } from './updateDatesInitialMonth.tsx';
import { updateViewBlueprintsEnabled } from './updateViewBlueprintsEnabled.tsx';

const actions = {
	loadProductSettings,
	updateDatesInitialMonth,
	updateViewBlueprintsEnabled,
};

const initialState: State = {
	productSettings: {
		status: 'idle',
	},
};

export const ProductSettingsStore: Store<
	State,
	{
		loadProductSettings: (
			...args: [] | [UUID: string, isSharedView: boolean]
		) => Action<State, Props, Promise<void>>;
		updateDatesInitialMonth: (initialMonth: number) => Action<State, Props, Promise<void>>;
		updateViewBlueprintsEnabled: (enabled: boolean) => Action<State, Props, Promise<void>>;
	},
	Props
> = createStore<State, typeof actions, Props>({
	name: 'ProductSettingsStore',
	initialState,
	actions,
});

export const useProductSettingsActions: HookActionsFunction<
	BoundActions<
		State,
		{
			loadProductSettings: (
				...args: [] | [UUID: string, isSharedView: boolean]
			) => Action<State, Props, Promise<void>>;
			updateDatesInitialMonth: (initialMonth: number) => Action<State, Props, Promise<void>>;
			updateViewBlueprintsEnabled: (enabled: boolean) => Action<State, Props, Promise<void>>;
		}
	>
> = createActionsHook(ProductSettingsStore);
